/* global app, gui */

app.controller('dialog_editWorkCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
        $scope.gui = {okButtonDisabled:true};
        $scope.position = {};
        
        $rootScope.$on("editWorkDialog", function(e,data){
            $scope.work = {}
            $scope.work.count = data.data.Menge;
            $scope.job = data.data
            gui.setSliderValue("editAnzahl", $scope.work.count);
        })
        
        $scope.infiniteVolunteersChanged = function(){
            if($scope.work.infiniteVolunteers){
                $scope.work.count = -1;
            }else{
                $scope.work.count = 0;
            }
        }
        
        $scope.updateWork = function ()
        {
            var newWork = {
                count: $scope.work.count,
                positionId: $scope.job.alle_positionen_id,
                shiftId: $scope.job.alle_schichten_id
            };
            
            console.log(newWork);
            NetworkService.callOperation("updateWork", newWork, function(response){
                if(response.isSuccessfull()){
                    AtlasNotification.info("Arbeit erfolgreich upgedatet.");
                    $rootScope.$emit("updateCalendar")
                }
            })
        }
    }])